import OrganizerApi from 'entities/organizer/api';
import { selectUser } from 'entities/user/selectors';
import { showMessageAction, showErrorAction } from 'containers/Notification/actions';
import { reloadAllTabsAction } from 'broadcastChannels/actions';

import { SWITCH_ORGANIZATION } from './constants';
import { switchOrganizationFailedAction, switchOrganizationSuccessAction } from './actions';

const changeOrganization = (action$, store) =>
  action$.ofType(SWITCH_ORGANIZATION).mergeMap(({ organizationId }) => {
    const state = store.getState();
    const user = selectUser(state);

    if (organizationId !== user?.organization.id) {
      return OrganizerApi.switchOrganization(organizationId)
        .concatMap(() => [
          showMessageAction('Changes Saved!'),
          switchOrganizationSuccessAction(),
          reloadAllTabsAction(),
        ])
        .catch((e) => [
          switchOrganizationFailedAction(e),
          showErrorAction('An error occurred while switching the organization, please try again.'),
        ]);
    }
    return [];
  });

export default [changeOrganization];
